<template>
  <div
    class="video-product"
    :class="{
      'video-product--active': active,
      'video-product--disabled': disabled
    }"
    @click="$emit('click')"
  >
    <div class="video-product__actions">
      <base-like-button
        v-model="innerFavorite"
        :show-icon="true"
        :readonly="!canLike"
      />
    </div>

    <!-- <img
      class="video-product__thumb"
      :src="`${ product.thumb }&w=200&h=268&fit=crop&fill=solid&fit-color=FFFFFF`"
      @click="$emit('click')"
    > -->
    <img
      class="video-product__thumb"
      :src="`${productImage.display_image}?w=200&h=268`"
    >
    <div
      v-if="product && product.brand"
      class="video-product__brand"
    >
      {{ product.brand.name }}
    </div>
    <div
      v-if="product && product.title"
      class="video-product__name"
    >
      {{ product.title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoCallProduct',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    productImage: {
      type: Object,
      default: () => {},
    },
    canLike: {
      type: Boolean,
      default: false,
    },
    favorite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerFavorite: false,
    };
  },
  computed: {
    product() {
      return this.productImage.product;
    },
  },
  watch: {
    favorite: {
      handler(value) {
        this.innerFavorite = value;
      },
      immediate: true,
    },
    innerFavorite(newVal) {
      this.addToFavorites();
    },
  },
  methods: {
    addToFavorites() {
      if (!this.canLike) {
        return;
      }
      if (this.innerFavorite) {
        this.$emit('like', this.product);
      } else {
        this.$emit('unlike', this.product);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$breakpoint-1: 769px;
.video-product{
  cursor: pointer;
  text-align: center;
  width: 128px;
  position: relative;
  // margin-top: 1rem;
  margin-bottom: 2rem;
  @media (min-width: $breakpoint-1) {
    width: 200px;
  }

  &__thumb{
    width: 128px;
    height: 160px;
    border-radius: 5px;
    object-fit: contain;
    margin-bottom: 12px;
    border: 2px solid transparent;
    transition: all 0.2s;
    @media (min-width: $breakpoint-1) {
      width: 200px;
      height: 268px;
    }
  }

  &--active &__thumb{
    border-color: $clementine;
  }
  &--disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  &__brand,
  &__name,
  &__price{
    font-family: $font-family-sans-serif-medium;
    font-style: normal;
    font-weight: 500;
    font-size: 0.5rem;
    line-height: 1;
    margin-top: 4px;
    @media (min-width: $breakpoint-1) {
      font-size: 0.875rem;
    }
  }

  &__actions{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    z-index: 1;
    top: 0.5rem;
    left: 0.5rem;
    right: 0.5rem;
  }
}
</style>
